import React from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  Stack,
  Typography,
} from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import LogoutIcon from '@mui/icons-material/Logout';
import RefreshIcon from '@mui/icons-material/Refresh';
import { DataService, StorageKey } from '../auth/DataService';
import { DarkTheme } from '@mercedes-benz/mui5-theme';

const AccessDeniedPage = () => {
  const userName = localStorage.getItem(StorageKey.userInfo_name) || 'Unknown';
  const userEmail =
    localStorage.getItem(StorageKey.userInfo_email) || 'Unknown';
  const userSub = localStorage.getItem(StorageKey.userInfo_sub) || 'Unknown';
  const appId = localStorage.getItem(StorageKey.userInfo_app_id) || 'N/A';
  const entitlements =
    localStorage.getItem(StorageKey.userInfo_ett_group) || 'None';
  const errorDetail = DataService.getAuthError();

  const handleLogout = async () => {
    await DataService.logout();
  };

  const handleRetry = async () => {
    // Clear state and restart login flow
    await DataService.logoutAndRelogin();
  };

  return (
    <ThemeProvider theme={createTheme(DarkTheme)}>
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#121212',
          padding: 2,
        }}
      >
        <Card
          sx={{
            maxWidth: 560,
            width: '100%',
            backgroundColor: '#1e1e1e',
            color: '#fff',
          }}
        >
          <CardContent sx={{ padding: 4 }}>
            <Stack spacing={3} alignItems='center'>
              <LockOutlinedIcon sx={{ fontSize: 64, color: 'error.main' }} />

              <Typography variant='h5' fontWeight='bold' textAlign='center'>
                Zugriff verweigert
              </Typography>

              <Typography
                variant='body1'
                textAlign='center'
                color='text.secondary'
              >
                Sie haben sich erfolgreich angemeldet, verfügen jedoch nicht
                über die erforderlichen Berechtigungen für diese Anwendung.
              </Typography>

              {errorDetail && (
                <Box
                  sx={{
                    width: '100%',
                    backgroundColor: 'rgba(211, 47, 47, 0.1)',
                    border: '1px solid rgba(211, 47, 47, 0.3)',
                    borderRadius: 1,
                    padding: 2,
                  }}
                >
                  <Typography variant='body2' color='error.light'>
                    {errorDetail}
                  </Typography>
                </Box>
              )}

              <Divider sx={{ width: '100%', borderColor: '#333' }} />

              <Box sx={{ width: '100%', textAlign: 'left' }}>
                <Typography
                  variant='subtitle2'
                  color='text.secondary'
                  gutterBottom
                >
                  Angemeldeter Benutzer:
                </Typography>
                <Typography variant='body2'>
                  <strong>Name:</strong> {userName}
                </Typography>
                <Typography variant='body2'>
                  <strong>E-Mail:</strong> {userEmail}
                </Typography>
                <Typography variant='body2'>
                  <strong>EMEA-ID:</strong> {userSub}
                </Typography>
                <Typography variant='body2'>
                  <strong>App-ID:</strong> {appId}
                </Typography>
                <Typography variant='body2'>
                  <strong>Berechtigungen:</strong> {entitlements}
                </Typography>
              </Box>

              <Divider sx={{ width: '100%', borderColor: '#333' }} />

              <Box sx={{ width: '100%', textAlign: 'left' }}>
                <Typography
                  variant='subtitle2'
                  color='text.secondary'
                  gutterBottom
                >
                  Was können Sie tun?
                </Typography>
                <Typography variant='body2' component='div'>
                  <ul style={{ paddingLeft: 20, margin: '4px 0' }}>
                    <li>
                      Bitten Sie Ihren Administrator, Ihnen die erforderlichen
                      Berechtigungsgruppen zuzuweisen.
                    </li>
                    <li>
                      Falls Sie mehrere Konten haben, melden Sie sich ab und
                      verwenden Sie ein anderes Konto.
                    </li>
                    <li>
                      Falls Ihre Berechtigungen kürzlich aktualisiert wurden,
                      klicken Sie auf „Erneut versuchen".
                    </li>
                  </ul>
                </Typography>
              </Box>

              <Stack
                direction={{ xs: 'column', sm: 'row' }}
                spacing={2}
                sx={{ width: '100%', pt: 1 }}
              >
                <Button
                  variant='contained'
                  color='primary'
                  startIcon={<RefreshIcon />}
                  onClick={handleRetry}
                  fullWidth
                >
                  Erneut versuchen
                </Button>
                <Button
                  variant='outlined'
                  color='error'
                  startIcon={<LogoutIcon />}
                  onClick={handleLogout}
                  fullWidth
                >
                  Abmelden
                </Button>
              </Stack>
            </Stack>
          </CardContent>
        </Card>
      </Box>
    </ThemeProvider>
  );
};

export { AccessDeniedPage };
